import { BrowserRouter } from 'react-router-dom';

// routes
import AllRoutes from '.';
import config from 'config';

const Routes = () => {
    return (
        <BrowserRouter
			basename={config.BR_BASENAME}
		>
            <AllRoutes />
        </BrowserRouter>
    );
};

export default Routes;
